/**
 * Check if an email is valid
 * @param email The email to check
 * @returns {boolean} Whether the email is valid or not
 */
export default function isEmailValid(email: string) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}
